import React from 'react'
import { getIcons } from '../components/Constant/Constant';



export  const getBackgroundClass = (label) => {
    switch (label.toLowerCase()) {
      case "gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };

  export const getStatusBgColor = (label) => {
    switch (label) {
      case "Fresh":
        return "bg-[#74F2C433] border-2 border-[#399E79]";
      case "Registered Client":
        return "bg-[#2280FF1A] border-2 border-[#2280FF]";
      case "Follow-up":
        return "bg-[#D2FAEC80] border-2 border-[#399E79]";
      case "Deal Lost":
        return "bg-[#FDB1B140] border-2 border-[#FDB1B1]";
      case "Not Interested":
        return "bg-[#FFBFA44D] border-2 border-[#FFBFA4]";
      case "Unanswered":
        return "bg-[#FFBFA44D] border-2 border-[#FFBFA4]";
      case "Retry Suitable":
        return "bg-[#74F2C433] border-2 border-[#399E79]";
      default:
        return "bg-[#74F2C433] border-2 border-[#399E79]";
    }
  };


 export  const interestLevel = [
    {
      value: "YkC7pUhxKKURN7AZjDhl",
      label: "Diamond",
      image: getIcons().diamond,
    },
    {
      value: "80OWCT8bC9H25c4lt83r",
      label: "Gold",
      image: getIcons().gold,
    },
    {
      value: "lIOauRSITzlqtQ3WwctM",
      label: "Silver",
      image: getIcons().silver,
    },
    {
      value: "N3ZumYbY3xL2II1Pajco",
      label: "Bronze",
      image: getIcons().bronze,
    },
  ];

  export const leadStatusList = [
    {
      label: "Fresh",
      value: "Fresh",
      image: getIcons().freshIcon,
    },
    {
      label: "Registered Client",
      value: "Registered Client",
      image: getIcons().registeredClient,
    },
    {
      label: "Follow-up",
      value: "Follow-up",
      image: getIcons().interestedIcon,
    },
    {
      label: "Deal Lost",
      value: "Deal Lost",
      image: getIcons().dealLostIcon,
    },
    {
      label: "Not Interested",
      value: "Not Interested",
      image: getIcons().notInterestedIcon,
    },
    {
      label: "Unanswered",
      value: "Unanswered",
      image: getIcons().unansweredIcon,
    },
    {
      label: "Retry Suitable",
      value: "Retry Suitable",
      image: getIcons().RetrySuitable,
    },
    {
      label: "Dealing",
      value: "Dealing",
      image: getIcons().dealingIcon,
    },
  ]; 

  export const statusIcons = Object.freeze([
    {
      label: "Fresh",
      image: getIcons().freshIcon,
    },
    {
      label: "Registered Client",
      image: getIcons().registeredClient,
    },
    {
      label: "Follow-up",
      image: getIcons().interestedIcon,
    },
    {
      label: "Deal Lost",
      image: getIcons().dealLostIcon,
    },
    {
      label: "Not Interested",
      image: getIcons().notInterestedIcon,
    },
    {
      label: "Unanswered",
      image: getIcons().unansweredIcon,
    },
    {
      label: "Retry Suitable",
      image: getIcons().RetrySuitable,
    },
    {
      label: "Dealing",
      image: getIcons().dealingIcon,
    },
  ]);